<template>
  <div class="input-box" :class="getValidationClasses()">
    <div class="input-box__label" v-html="label" />
    <div class="input-box__body">
      <Icon class="input-box__icon" :icon="icon" @click="clicked('icon')" />
      <div class="input-box__value" @click.self="clicked('field')">
        <slot name="clear" />
        <slot name="value">
          <span :class="{
            'input-box__value-text': true,
            'input-box__value-text--active': highlight
          }" @click="clicked('field')">{{ value }}</span>
        </slot>
      </div>
    </div>

    <div v-if="errors.has(validationField(validateAs))" class="v-field-error">{{ errors.first(validationField(validateAs)) }}</div>
    <slot />
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import CustomControlValidationMixin from '@/components/CustomControlValidationMixin'
import Icon from '@/components/Icon.vue'

@Component({
  mixins: [
    CustomControlValidationMixin,
  ],
  props: {
    label: {
      type: String,
      required: false,
      default: () => '&nbsp;',
    },
    icon: {
      type: String,
      default: () => '',
    },
    value: {
      type: String,
    },
    data: {
      // Custom data to be passed on to 'click' handler
    },
    highlight: {
      type: Boolean,
      required: false,
      default: () => false,
    },   
    validateAs: {
      type: String,
      required: false,
    }, 
  },
  components: {
    Icon,
  },
})
export default class InputBox extends Vue {
  clicked (element) {
    log.debug('InputBox.clicked', element)
    this.$emit('click', element)
  }
}
</script>

<style lang="scss">
@import '../forms/FormValidationIndicator.scss';

.input-box {
  @include form-validation-indicator(12px, 30px);
  font-weight: 300;
  outline: none;

  &__body {
    background-image: url('/assets/images/input-box-underline.png');
    background-position-x: right;
    background-position-y: bottom;
    background-repeat: no-repeat;
    user-select: none;
  }

  &--blue-border &__body {
    background-image: url('/assets/images/input-box-underline-blue.png');
  }

  &.field-invalid &__body {
    background-image: url("/assets/images/input-box-underline-red.png");
  }

  &__label {
    font-size: 10px;
    &::after {
      content: "\200B";
    }
  }

  &__value {
    font-size: 14px;
    padding-bottom: 7px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__value-text {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__value-text--active {
    color: #A0D5FF;
    border-left: 1px solid transparent;
    animation: PulseAttention 1s cubic-bezier(0, 1, 0, 1) forwards infinite
  }

  &__icon {
    font-size: 20px;
    float: right;
    padding: 0 0 5px 2px;
    width: 28px;
    height: 28px;
    margin-bottom: 0;
    text-align: center;
    cursor: pointer;

    @include media(tablet) {
      color: #fff;
    }

    &.figure--v {
      font-size: 6px;
      padding-top: 6px;
      padding-right: 5px;
    }
    &.figure--map {
      padding-right: 3px;
    }
    &.figure--calendar {
      padding-right: 5px;
      font-size: 18px;
      padding-top: 0;
    }
  }

  &.field-invalid &__icon {
    color: inherit;
  }

  @keyframes PulseAttention {
    50% {
      border-left-color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/InputBox.vue